import React, { useEffect, useMemo, useState } from "react";
import styles from "./HrmDashboard.module.css";
import { useAuth } from "../../components/context/Auth";
import HrmFilters from "../../components/updatedComponents/hrm/HrmFillters";
import SearchBar from "../../components/updatedComponents/FormComponents/SearchBar";
import { AllDesignation } from "./HrmData";
import DropDown from "../../components/updatedComponents/FormComponents/DropDown";

const HrmDashboard = () => {
  const { mode } = useAuth();

  const [keyword, setKeyword] = useState("");
  const [selectedFilter, setSelectedFilter] = useState("Employee");
  const [role, setRole] = useState([]);
  useEffect(() => {
    if (AllDesignation) {
      setRole(
        AllDesignation.map((r) => ({
          label: r.name,
          value: r.name,
        })),
      );
    }
  }, []);

  const statusCards = [
    {
      status: "Employee",
      count: 42,
      subtitle: "38 Active",
    },
    {
      status: "Auto Present",
      count: 28,
      subtitle: "Default Attendance",
    },
    {
      status: "Manual Present",
      count: 7,
      subtitle: "Marked By HR",
    },
    {
      status: "Absent",
      count: 4,
      subtitle: "Today",
    },
    {
      status: "Half-Day",
      count: 3,
      subtitle: "Today",
    },
    {
      status: "Salary Balance",
      amount: 145000,
      subtitle: "This Month",
    },
  ];

  const employees = [
    {
      id: 1,
      name: "Rahul Sharma",
      department: "Production",
      status: "Auto Present",
    },
    {
      id: 2,
      name: "Amit Singh",
      department: "Accounts",
      status: "Manual Present",
    },
    {
      id: 3,
      name: "Neha Verma",
      department: "HR",
      status: "Absent",
    },
    {
      id: 4,
      name: "Rohan Kumar",
      department: "Store",
      status: "Half-Day",
    },
    {
      id: 5,
      name: "Priya Patel",
      department: "Sales",
      status: "Leave",
    },
    {
      id: 6,
      name: "Ankit Gupta",
      department: "Dispatch",
      status: "Auto Present",
    },
  ];

  const STATUS_COLORS = {
    // "Auto Present": {
    //   light: "#bdf8d6",
    //   dark: "#173524",
    //   border: "#22C55E",
    // },
    // "Manual Present": {
    //   light: "#f7db97",
    //   dark: "#463816",
    //   border: "#F59E0B",
    // },
    // Absent: {
    //   light: "#f1a9a9",
    //   dark: "#431D1D",
    //   border: "#EF4444",
    // },
    // "Half-Day": {
    //   light: "#a2c5f5",
    //   dark: "#172C49",
    //   border: "#3B82F6",
    // },
    // Leave: {
    //   light: "#c4a4f5",
    //   dark: "#31244A",
    //   border: "#8B5CF6",
    // },
    default: {
      light: "#ffffff",
      dark: "#1B1D21",
      border: "#cccccc",
    },
  };

  const getRowStyle = (status) => {
    const color = STATUS_COLORS[status];

    if (!color) {
      return {
        background: mode ? "#1B1D21" : "#FFFFFF",
        // borderLeft: "5px solid transparent",
      };
    }

    return {
      background: mode ? color.dark : color.light,
      //   borderLeft: `5px solid ${color.border}`,
    };
  };

  const filteredEmployees = useMemo(() => {
    return employees.filter((emp) => {
      const search =
        emp.name.toLowerCase().includes(keyword.toLowerCase()) ||
        emp.department.toLowerCase().includes(keyword.toLowerCase());

      const filter =
        selectedFilter === "Employee" ? true : emp.status === selectedFilter;

      return search && filter;
    });
  }, [keyword, selectedFilter]);

  const gridColumns = "0.6fr 2fr 2fr 1.2fr";

  return (
    <div
      className={styles.hrm}
      style={mode ? { background: "#2C2E33", border: "none" } : {}}
    >
      <div className={styles.hrm_body}>
        <div
          className={styles.hrm_filters_wrapper}
          style={mode ? { background: "#232529" } : {}}
        >
          <HrmFilters
            mode={mode}
            headerData={statusCards}
            selectedFilter={selectedFilter}
            handleClick={setSelectedFilter}
            type="hrm"
          />
        </div>
      </div>

      <div className={styles.hrm_data}>
        <div className={styles.hrm_data_filters}>
          <SearchBar
            placeholder="Search Employee..."
            value={keyword}
            padding="5px 10px"
            onChange={(e) => setKeyword(e.target.value)}
            onClear={() => setKeyword("")}
          />
          <DropDown
            label={"Designation"}
            listLabel={"All"}
            options={role}
            onSelect={(option) => setRole(option.value)}
            onReject={() => setRole(null)}
          />
        </div>

        <ul className={styles.hrmTable}>
          <li
            className={styles.hrmTableHeader}
            style={{
              gridTemplateColumns: gridColumns,
              background: mode ? "#232529" : "#d9dce5",
              color: mode ? "#fff" : "#646b88",
            }}
          >
            <div>S.No.</div>
            <div>Employee</div>
            <div>Designation</div>
            <div>Status</div>
          </li>
          {filteredEmployees.map((employee, index) => (
            <li
              key={employee.id}
              className={`${styles.hrmTableRow} ${
                mode ? styles.hrmTableRowDark : ""
              }`}
              style={{
                gridTemplateColumns: gridColumns,
                ...getRowStyle(employee.status),
              }}
            >
              <div>{index + 1}</div>
              <div>{employee.name}</div>
              <div>{employee.department}</div>
              <div>{employee.status}</div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default HrmDashboard;
